// extracted by mini-css-extract-plugin
export default {"searchContainer":"searchContainer--1Kgp0","focused":"focused--mfS7w"};